import { Text, theme, Avatar } from 'components';
import React from 'react';
import styled from 'styled-components';

import { capitalize } from 'lodash';
import { featureEnabled } from 'utils';
import { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';
import { ParsedSupraLockboxJsonType } from '../../../api/SupraLockboxController';
import SupraCoopTypeTag from '../MLSStaffPages/Tags/CoopTypeTag';

type Label =
  | ParsedSupraLockboxJsonType['parsedOwner']
  | ParsedSupraLockboxJsonType['parsedAssignee'];

const SearchLabel = (label: Label, isMlsUser: boolean) => {
  if (!label) return <></>;

  const {
    name,
    firstName,
    lastName,
    logo,
    type,
    mlsNumbers,
    branchName,
    orgName,
    coopType,
    usingDataConnectAPI,
  } = label;

  const props: any = {};
  if (type === 'user') {
    props.user = {
      firstName,
      lastName,
      avatarFilestackId: logo,
      mlsNumbers,
      branchName,
    };
    if (logo) {
      props.backgroundColor = 'background';
    }
  } else {
    props.user = {
      firstName: name,
    };

    if (logo) {
      props.src = logo;
      props.backgroundColor = 'background';
    }
  }
  const mlsNumbersString =
    mlsNumbers &&
    mlsNumbers
      .map(
        ({ number, board, mlsUniqueId }) =>
          `${board}: ${
            featureEnabled('membershipKeyholderIdSupportFeature', 1) &&
            usingDataConnectAPI &&
            mlsUniqueId
              ? mlsUniqueId
              : number
          }`,
      )
      .join(', ');
  return (
    <>
      <FlexContainer>
        <Avatar {...props} />
        <NameContainer>
          <Text style={{ marginLeft: '5px' }} ellipsis block>
            {featureEnabled('improvedLockboxAssignmentFeature') &&
            type === 'office'
              ? `${branchName} ID#${name}`
              : name}
          </Text>
          <StyledType block>
            {capitalize(type === 'org' ? 'brokerage' : type)}
          </StyledType>
          {coopType && coopType !== SupraCoopType.PRIMARY && (
            <SupraCoopTypeTag coopType={coopType} />
          )}
        </NameContainer>
      </FlexContainer>
      {isMlsUser &&
      (featureEnabled('improvedLockboxAssignmentFeature')
        ? type === 'office'
        : type === 'branch') ? (
        <AdditionalInfoContainer>
          <StyledType>{orgName}</StyledType>
        </AdditionalInfoContainer>
      ) : null}
      {mlsNumbersString ? (
        <AdditionalInfoContainer>
          <StyledType>{mlsNumbersString}</StyledType>
        </AdditionalInfoContainer>
      ) : null}
      {!isMlsUser && branchName ? (
        <AdditionalInfoContainer>
          <StyledType>{branchName}</StyledType>
        </AdditionalInfoContainer>
      ) : null}
    </>
  );
};

const StyledType = styled(Text)`
  margin: 0px 5px;
  color: ${theme.gray6};
  font-weight: 500;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 85%;
`;

const AdditionalInfoContainer = styled.div`
  padding-left: 32px;
`;

export default SearchLabel;
